var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVolumeControllerPlain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.36963 11.2729C4.36963 14.5011 6.43048 17.2452 9.30734 18.2681V19.304C4.28263 19.1716 0.25 15.0578 0.25 9.99999C0.25 4.94212 4.28241 0.82814 9.30734 0.695674V4.28144C6.43032 5.30071 4.36963 8.04513 4.36963 11.2729Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5043 14.9925C13.4518 17.0455 10.1234 17.0455 8.07044 14.9925C6.24855 13.1691 6.0439 10.3439 7.45623 8.29462L9.87281 10.7107C10.246 11.0854 10.8511 11.0854 11.2246 10.7107C11.5978 10.3362 11.5978 9.73192 11.2246 9.35745L8.80751 6.94136C10.8553 5.53076 13.6822 5.73345 15.5041 7.55682C17.5571 9.60982 17.5571 12.9395 15.5041 14.9925H15.5043ZM7.39468 6.88032C4.9687 9.30778 4.9687 13.2417 7.39468 15.6655C9.82091 18.0932 13.7542 18.0932 16.1804 15.6655C18.6066 13.2417 18.6066 9.30778 16.1804 6.88032C13.7544 4.45656 9.82091 4.45656 7.39468 6.88032Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeControllerPlain);
export default __webpack_public_path__ + "static/media/volume_controller_plain.5c30f0ee00fe78a6a51e5168fc85a840.svg";
export { ForwardRef as ReactComponent };